import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router, NavigationExtras} from '@angular/router';
import {YearService} from '../../../../../shared-components/year/year.service';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {StudentSummaryService} from '../../../student-summary.service';
import {CardMealService} from './card-mealService';
import { MatDialog } from '@angular/material/dialog';
import {MealServiceCardModalComponent} from './meal-service-card-modal/meal-service-card-modal.component';
import {Card} from '../../../card-container/card/card';
import {LoginService} from '../../../../../shared-modules/login/login.service';
import {AutoUnsubscribe} from 'ngx-auto-unsubscribe';
import {interval, Subscription} from 'rxjs';
import {UserService} from '../../../../../shared-components/user/user.service';
import {OnlinePaymentConfiguration} from '../../../../online-payment/models/online-payment-config.model';
import {Year} from '../../../../../shared-components/year/year.model';
import { Portal } from '../../../../../shared-components/portal.model';
import { Student360Service } from '../../../../student360.service';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-meal-service-card',
    templateUrl: './meal-service-card.component.html',
    styleUrls: ['./meal-service-card.component.css']
})

export class MealServiceCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    card: Card;
    v10: boolean;
    balance = 0;
    absBalance = 0; // Absolute value
    rolloverBalance = 0;
    deposits = 0;
    charges = 0;
    mealLedger: CardMealService;
    onlinePaymentConfiguration: OnlinePaymentConfiguration = new OnlinePaymentConfiguration();
    userType: number;
    parentPortalShowOnlinePayment: boolean;
    student360Year: Year;
    showPay = false;
    parentAssignedPortalsSubscription: Subscription;
    portals: Portal[] = [];

    constructor(private userService: UserService,
                private loginService: LoginService,
                private dialog: MatDialog,
                private yearService: YearService,
                private studentService: StudentService,
                private studentSummaryService: StudentSummaryService,
                private parentPortalService: Student360Service,
                private router: Router) {
        this.studentService.observableOnlinePaymentConfigurationStream$.subscribe(onlinePaymentConfiguration => {
            if (onlinePaymentConfiguration) {
                this.onlinePaymentConfiguration = onlinePaymentConfiguration;
            }
        });

        this.parentAssignedPortalsSubscription = this.parentPortalService.observableParentAssignedPortalsStream$
            .subscribe(portals => {
                if (portals.length > 0) {
                    this.portals = portals.filter(portal => !portal.Deleted);
                }
            });
    }

    ngOnInit() {
        this.v10 = this.loginService.LoginSettings.V10;
        this.card = this.data;
        this.onlinePaymentConfiguration = this.studentService.onlinePaymentConfiguration;
        this.parentPortalShowOnlinePayment = this.loginService.LoginSettings.ParentPortalShowOnlinePayment;
        this.userType = this.userService.userType;
        this.student360Year = this.yearService.student360Year;
        if (!this.v10 && this.userType == 2 && this.portals.filter(o => o.PortalName == "Online Payment" && o.Disabled == false && o.ShowAsMenu == true && o.Deleted == false).length > 0) {
            this.showPay = true;
        }
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getMealBalance();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getMealBalance() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardMealService(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe(response => {
            if (response.ok) {
                this.mealLedger = response.body[0];
                this.balance = this.mealLedger.Balance;
                this.absBalance = Math.abs(this.mealLedger.Balance);
                this.rolloverBalance = this.mealLedger.Rollover_Balance;
                this.deposits = this.mealLedger.Deposits;
                this.charges = this.mealLedger.Charges;
            }
        });
    }

    viewDetailsClick() {
        this.router.navigateByUrl('/student360/mealService');
    }

    payClick() {
        const navigationExtras: NavigationExtras = {
            // The view to Meal Accounts
            queryParams: {
                'selectedView': 2
            }
        };
        this.router.navigate(['/student360/onlinePayment'], navigationExtras);
    }

    checkIfNegative(balance: number) {
        // If negative or zero return class
        if (balance <= 0) {
            return 'isNegative';
        }
    }

    isDisabled() {
        if (this.card.disabled) {
            return 'disabledColor';
        } else {
            return 'enabledColor';
        }
    }

    cardClick() {
        if (!this.card.disabled) {
            this.dialog.open(MealServiceCardModalComponent, {
                minWidth: '40vw',
                data: {mealLedger: this.mealLedger, showPay: this.showPay},
                disableClose: true,
                autoFocus: false
            });
        }
    }
}
